import React from "react";
import { useSelector } from "react-redux";
import "./portal.css";
// import user_icon from "./user.png";

const Trainee = () => {
  const trainee = useSelector((state) => state.trainee);

  return (
    <div className="loggedin-trainee-container">
      <div className="loggedin-trainee-inner">
        {/* <img
          alt="User Icon"
          src={user_icon}
          className="loggedin-trainee-logo"
        /> */}
        <div className="loggedin-trainee-details-container">
          <p>{trainee?.traineeDetails?.name || "No name available"}</p>
        </div>
      </div>
    </div>
  );
};

export default Trainee;
